// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-card {
  --ion-background-color: var(--planeed-color-white);
  margin: 10px 0 0;
  border-radius: 0;
  box-shadow: 0 0 0;
  padding: 10px 0;
}
@media only screen and (min-width: 460px) {
  ion-card {
    border-radius: 10px;
    margin: 20px 10px;
  }
}

ion-list {
  padding: 0;
  margin: 0;
}

ion-row {
  margin: 0;
}
ion-row ion-icon {
  padding: 4px 0 0 0;
  width: 13px;
  height: 13px;
}

p {
  display: inline;
}

.social-counter {
  margin-bottom: 10px;
  color: var(--ion-color-medium);
  padding: 4px 10px 0 4px;
}

.social-counter span {
  margin: 0 20px 0 5px;
  font-size: 13px;
}

ion-item img {
  width: 70px;
  height: 70px;
  object-fit: cover;
  margin: 0 10px 0 0;
  border-radius: 50%;
}

h3 {
  font-size: 15px;
  cursor: pointer;
}

.member-type {
  --padding-start: 0px;
  width: 180px;
}

ion-select, p {
  padding: 0;
  margin: 0;
  color: var(--ion-color-secondary);
  font-size: 12px;
}

img {
  cursor: pointer;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
